<script lang="ts">
    import toast from "svelte-french-toast";
    import {clipboard} from '@skeletonlabs/skeleton';

    export let buildingId: string;
    export let buildingImageUrl: string;
    export let buildingName: string;
    export let referralCode: string|null|undefined;
    export let url: string;

    let shareURL = '';

    $: {
        shareURL = new URL(url);
        if (referralCode) {
            shareURL.searchParams.set("referrer", referralCode);
        }
    }

    function showToast() {
        toast.success('Share link copied to clipboard!', {
            position: 'top-center',
            duration: 2000,
            icon: '📋',
        });
    }
</script>

<section class="mt-16">
    <h2 class='h2 text-xl font-bold'>Where To Go Next</h2>
    <div class="flex flex-col md:flex-row items-center justify-between mt-5 gap-1 text-white">
        <a class="w-full" href="/add-review?b_id={buildingId}">
            <div style="background: linear-gradient(170deg, #517ec0df, #5e93acdf), url({buildingImageUrl}); background-size: cover;"
                 class="flex flex-col justify-center h-[250px] px-12 border-[2px] border-white hover:border-primary-200 hover:cursor-pointer rounded-t-2xl md:rounded-bl-2xl md:rounded-tr-none md:rounded-tl-2xl">
                <span class="text-sm">Lived here before?</span>
                <span class="text-2xl font-bold">Add a Review for {buildingName}</span>
            </div>
        </a>
        <button use:clipboard={shareURL.toString()}
                on:click={showToast}
                class="text-left w-full">
            <div style="background: linear-gradient(170deg, #93b565df, #76bac2df), url('/placeholders/downtown/1.webp'); background-size: cover;"
                    class="w-full flex flex-col justify-center bg-blue-500 h-[250px] px-12 border-[2px] border-white hover:border-primary-200 hover:cursor-pointer">
                <span class="text-sm">Know someone who did?</span>
                <span class="text-2xl font-bold">Send {buildingName} to a friend</span>
            </div>
        </button>
        <a href="/buildings/toronto" class="w-full">
            <div style="background: linear-gradient(170deg, #BC9F8Acc, #363636cc), url('/placeholders/downtown/4.webp'); background-size: cover;"
                 class="w-full flex flex-col justify-center bg-yellow-500 h-[250px] px-12 border-[2px] border-white hover:border-primary-200 hover:cursor-pointer rounded-b-2xl md:rounded-tr-2xl md:rounded-bl-none md:rounded-br-2xl">
                <span class="text-2xl font-bold">Browse more buildings</span>
            </div>
        </a>
    </div>
</section>